<script setup lang="ts">
const {
  errorMessages = [],
  readonly = false,
  disabled = false,
  label = '',
  placeholder = '',
  bgColor = 'white',
  rounded = 'lg',
  hideDetails = 'auto',
  itemTitle = null,
  itemValue = null,
  required = false,
} = defineProps<{
  errorMessages?: string | string[];
  readonly?: boolean;
  disabled?: boolean;
  label?: string;
  placeholder?: string;
  bgColor?: string;
  rounded?: string | number | boolean;
  hideDetails?: boolean | 'auto';
  itemTitle?: string | null;
  itemValue?: string | null;
  required?: boolean;
}>();

const select = defineModel<string | number>();
</script>
<template>
  <v-select
    v-model="select"
    variant="solo"
    :hide-details="hideDetails"
    :error-messages="errorMessages"
    :placeholder="placeholder"
    :label="label"
    :readonly="readonly"
    :disabled="disabled"
    :bg-color="bgColor"
    :rounded="rounded"
    :item-title="itemTitle"
    :item-value="itemValue"
  >
    <template #label> {{ label }}<span v-if="required" class="text-error"> *</span> </template></v-select
  >
</template>

<style scoped>
:deep(.v-label) {
  color: #414156 !important;
  opacity: 1 !important;
}

:deep(.v-input__control) {
  overflow: visible;
}

:deep(.v-field) {
  border: 1px solid rgba(var(--v-border-color), var(--v-border-opacity));
  box-shadow: none !important;
  overflow: visible;
}

:deep(.v-field--focused) {
  border-color: rgb(var(--v-theme-primary));
}

:deep(.v-field--error) {
  border-color: rgb(var(--v-theme-error)) !important;
}

:deep(.v-field--error .v-field__outline),
:deep(.v-field__outline) {
  display: none;
}

:deep(.v-field__overlay) {
  display: none;
}
</style>
